import React, { Component } from 'react'

class PauseIcon extends Component {
    render() {
        return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="bi bi-pause" viewBox="0 0 16 16">
            <path d="M6 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5z"/>
      </svg>
    }
}

export default PauseIcon